import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/app/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/features-background-left.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/features-background-right.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/hero-background-gradient-mobile.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/hero-background-gradient-xl.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/hero-backgrund-gradient-desktop.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/lobby-background.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/partners-background.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/quotes-background.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/team-background.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/backgrounds/team-grid.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/american-football.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/arrow-cursor.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/banner.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/dollar-badge.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/ESL.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/euro-badge.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/G2.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/language-badge.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/language-dropdown.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/medal-badge.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/phone-1.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/phone-2-dark.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/phone-2-light.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/phone-3.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/phone-4.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/prize-10000.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/features/tennis.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/england.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/finland.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/france.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/germany.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/india.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/italy.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/japan.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/kenya.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/netherlands.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/norway.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/poland.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/portugal.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/saudi-arabia.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/spain.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/ukraine.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/flags/usa.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/phone.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/prize_drop.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/progressive_board_game.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/reels.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/scratch_card.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Casino/tripple_wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Jackpots/Jackpots 2.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Jackpots/Jackpots 3.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Jackpots/Jackpots.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/American Football/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/American Football/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/American Football/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/American Football/Total TDs.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Baseball/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Baseball/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Baseball/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Baseball/Total Runs.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Basketball/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Basketball/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Basketball/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Basketball/Total Points.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Football/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Football/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Football/Pick6.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Football/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Football/Total Goals.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Ice Hockey/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Ice Hockey/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Ice Hockey/Pick6.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Ice Hockey/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Ice Hockey/Total Goals.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/American-Football.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/Baseball.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/Basketball.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/Football.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/Ice-Hockey.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/MMA.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/icons/Tennis.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/MMA/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/MMA/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/MMA/Total Rounds.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Tennis/Coupon.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Tennis/Double Wheel.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Tennis/Quiz.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/games/Sports/Tennis/Total Goals.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/lobby/brand-new-badge.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/lobby/lobby-phone-2.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/lobby/lobby-phone.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/lobby/star-badge.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/lobby/trophy-badge.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/10Bet.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/888sport.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/alt-logo.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/altenar.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/appsFlyer.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/arland.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/b2Tech.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/BetPlay.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/BetToMax.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Bingoal.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/BoaBet.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/bragg.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/btoBet.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/captainUp.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/comeOn.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Esportiva-Bet.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/EstrelaBet.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Evona.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/fastrack.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/firebase.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/gig.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/GOAT.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/jacks-testimonial.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/jacks.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/jumpman.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/kambi.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/LottoLand-Logo.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/lucky7Ventures.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/main-logo.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/MrBit.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/MrQ.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/openBet.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/optimove.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/premierBet.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/prideBet-testimonial.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/prideBet.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Rootz.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/RubyPlay.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/salesforce.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/switchAnalytics.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/twilio.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/xtremepush.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Yeet.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/logos/Yuugado.png");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-1.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-2.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-3.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-4.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-5.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-6.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-7.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/stickers/sticker-8.svg");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/adam.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Andrej.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/ben.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/bonham.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/chris.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Davi.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Iryna.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/jack.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/jose.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/liliia.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Lorraine.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/marc.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/marko.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Nemanja.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/Nicholas.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/paul.webp");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/assets/images/team/ricky.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/common/AnimatedComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Cursor/Cursor.tsx");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Features/Feature.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CoinsLottie"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Features/Markets/CoinsLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ColorWheelLottie"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Features/Solution/ColorWheelLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stickers"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Footer/Stickers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Loader/Loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Navbar/NavbarDesktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Navbar/NavbarMobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logos"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Partners/Logos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Swiper"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Quotes/Swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Swiper"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/Team/Swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/components/WorkWithUs/WorkWithUs.tsx");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"DM_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"dmSans\"}");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/Users/gvanvuuren/spaces/splash/splash-frontend-apps/apps/mkt-site/node_modules/slick-carousel/slick/slick-theme.css");
